export interface IOrganisation {
  id?: any;
  organizationId?: string;
  organizationName?: string;
  blocked?: boolean;
  licenseValidTo?: Date | null;
}

export const defaultValue: Readonly<IOrganisation> = {
  id: '',
  organizationId: '',
  organizationName: '',
  blocked: false,
  licenseValidTo: null
};
